export { default } from './MontlyHistogramCarousel';
